import { render, staticRenderFns } from "./RepositionOrders.vue?vue&type=template&id=4ce442d2&scoped=true&"
import script from "./RepositionOrders.vue?vue&type=script&lang=js&"
export * from "./RepositionOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce442d2",
  null
  
)

export default component.exports